
import { IListItem } from "@/models/common";
import { defineComponent, PropType, reactive } from "vue";
import { StringUtil } from "../../utils/string-util";

export default defineComponent({
  props: {
    item: {
      type: Object as PropType<IListItem>,
      required: true,
    },
    isDefaultDetail: {
      type: Boolean,
      default: true,
    },
  },
  name: "doctor item",
  setup(props) {
    const state = reactive({
      // doctorKey: props.doctorKey,
      item: props.item,
      isDefaultDetail: props.isDefaultDetail,
    });

    const getProfiles = (profiles: String) => {
      return StringUtil.split(profiles?.toString(), "\n");
    };

    return {
      state,
      getProfiles,
      //  doctorItem
    };
  },
});
